import React, { useState } from 'react';
import DashboardWrapper from '../../components/dashboard/dashboardWrapper/DashboardWrapper';
import LogPostsContainer from '../../components/dashboard/LogPost/LogPostsContainer';
import CustomDatePicker from '../../components/dashboard/customDatePicker/CustomDatePicker';
import styles from '../../styles/logpost.module.css';

type DateOrNull = Date | null;
type DateRangeArray = [DateOrNull, DateOrNull];

function MyPosts() {
  const [dateRange, setDateRange] = useState<DateRangeArray>([null, null]);
  const [selectedDays, setSelectedDays] = useState<number>(-1);
  const [showDatePicker, setShowDatePicker] = useState<boolean>(false);
  return (
    <DashboardWrapper
      heading="My Posts"
      rightHeaderComponent={
        <div className={styles.logPostHeaderDiv}>
          <CustomDatePicker
            selectedDays={selectedDays}
            showDatePicker={showDatePicker}
            dateRange={dateRange}
            setDateRange={setDateRange}
            setSelectedDays={setSelectedDays}
            setShowDatePicker={setShowDatePicker}
          />
        </div>
      }
    >
      <LogPostsContainer
        selectedDays={selectedDays}
        setSelectedDays={setSelectedDays}
        dateRange={dateRange}
        setDateRange={setDateRange}
      />
    </DashboardWrapper>
  );
}

export default MyPosts;
